import React from 'react';
import FeedbackDashboardCard, {
  FeedbackDashboardCardProps,
} from 'shared/components/Feedback/FeedbackDashboardCard';
import TrueImpactLoading from 'shared/components/TrueImpactLoading';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { RequestState } from 'shared/auth/hooks/useRequestState';
import LoadMore from 'shared/hooks/LoadMore';

const StyledDiv = styled.div`
  padding-top: 16px;
  padding-bottom: 32px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  .no-match-text {
    text-align: center;
    margin-top: 20px;
  }
`;

interface FeedbackRowsProps {
  loadingFirstPage: boolean;
  requestState: RequestState<unknown>;
  rows: FeedbackDashboardCardProps[];
  loadMore?: () => unknown;
}

const observerOptions: IntersectionObserverInit = { rootMargin: '300px 0px' };
const FeedbackRows: React.FC<FeedbackRowsProps> = ({
  loadingFirstPage,
  rows,
  requestState,
  loadMore,
}) => {
  if (
    (requestState.type === 'REQUEST_INIT' ||
      requestState.type === 'REQUEST_START') &&
    rows.length === 0
  ) {
    return <TrueImpactLoading />;
  }
  if (requestState.type === 'REQUEST_ERROR') {
    return (
      <StyledDiv>
        <TrueImpactText variant="heading-subheading" className="no-match-text">
          Unable to load feedbacks, please try again later.
        </TrueImpactText>
      </StyledDiv>
    );
  }
  if (rows.length === 0) {
    return (
      <StyledDiv>
        <TrueImpactText variant="heading-subheading" className="no-match-text">
          No match found.
        </TrueImpactText>
      </StyledDiv>
    );
  }
  return (
    <StyledDiv>
      {loadingFirstPage && requestState.type === 'REQUEST_START' && (
        <TrueImpactLoading />
      )}
      {rows.map((r, i) => (
        <FeedbackDashboardCard key={i} {...r} clickable={true} />
      ))}
      {loadMore && (
        <LoadMore loadMore={loadMore} options={observerOptions}>
          <TrueImpactLoading />
        </LoadMore>
      )}
    </StyledDiv>
  );
};

export default React.memo(FeedbackRows);
